export const AUTH_ERRORS = {
  clientTokenManager: 'ClientTokenManagerError',
  loginCallback: 'LoginCallbackError',
  loginCallbackPKCE: 'LoginCallbackPKCEError',
} as const;
